const VerticalDivider = () => {
	return <div className="bg-rcrm-divider w-[2px] h-full" />;
};

export default VerticalDivider;
